import { useEffect, useMemo, useRef } from 'react'
import { prop, isNil, isEmpty, pickBy } from 'ramda'
import { langStorage } from '../../i18n/i18nUtils'
import { getQueryParams, isPammRef } from './utils'
import { useLocation } from 'react-router-dom'

function useRedirectIn10SecBase () {
  let tmtId
  return (redirect) => {
    useEffect(() => {
      if (redirect) {
        if (tmtId) clearTimeout(tmtId)
        const lang = langStorage.getShort() || 'en'
        const url = prop(lang, redirect.url)
        if (url) {
          tmtId = setTimeout(() => { window.location.href = url }, 10000)
        }
      }
    }, [redirect, langStorage.getShort()])
  }
}

const useRedirectIn10Sec = useRedirectIn10SecBase()

function usePrevious (value) {
  const ref = useRef()
  useEffect(() => {
    ref.current = value
  })
  return ref.current
}

/**
 * @param {string} name
 * @param {?string | ?number} value
 * @param {func} presetValue
 */
function usePresetValue (name, value, presetValue) {
  return useEffect(() => {
    if (!isNil(value) && value !== '') {
      presetValue(value)
    }
  }, [value, name])
}

function useResidenceDependentVisibility ({
  residenceCountry, requiredForCountries, name, residenceDependentFields, onHide, onShow
}) {
  return useEffect(() => {
    if (!requiredForCountries || !requiredForCountries.length ||
      !residenceCountry || !residenceCountry.length ||
      !residenceDependentFields.includes(name)) return

    const shouldBeShownForCountry = requiredForCountries.includes(residenceCountry)
    if (!shouldBeShownForCountry) {
      onHide()
    } else {
      onShow()
    }
  }, [residenceCountry, requiredForCountries, name])
}

function useParamsObj ({ brokerGroup, utmCampaign, deptCode, fundId, search, platform, lang, ctierId }) {
  return useMemo(() => {
    const paramsObj = { brokerGroup, utmCampaign, deptCode, fundId, platform, lang, ctierId }
    const isNotEmpty = (val) => !isNil(val) && !isEmpty(val)
    const filledParmsObj = pickBy(isNotEmpty, paramsObj)
    if (!brokerGroup && !utmCampaign && !deptCode && !fundId && !!search) {
      return {
        ...filledParmsObj,
        ...getQueryParams(search)
      }
    }
    return filledParmsObj
  }, [brokerGroup, utmCampaign, deptCode, fundId, search, platform, lang, ctierId])
}

function usePammRefId () {
  const location = useLocation()

  return useMemo(() => {
    const urlSearch = new URLSearchParams(location.search)
    return isPammRef(urlSearch.get('ref_id'))
  }, [])
}

export { useRedirectIn10Sec, usePrevious, usePresetValue, useResidenceDependentVisibility, useParamsObj, usePammRefId }
